import type { FC } from "react";
import happyBird from "../../../../components/status/resources/happy_bird_RGB.svg";
import annaLogo from "../../../../resources/annaLogo.svg";
import styles from "./closeView.module.scss";

export const CloseView: FC = () => (
  <div className={styles.status}>
    <div className={styles.centerBlock}>
      <div className={styles.logo}>
        <img src={annaLogo} alt="logo" />
      </div>
      <div className={styles.illustration}>
        <img src={happyBird} alt="illustration" />
      </div>
      <div className={styles.text} role="heading" aria-level={1}>
        Now you can close this window
      </div>
    </div>
  </div>
);
